import {FILTER_NAMES} from '../base.js'
import {LISTING_SECTION_IDS} from './listingSections.js'

export const BODY_TYPE = 'bodyType'
export const CATEGORY_1_ID = 'category1Id'
export const CITY_ID = 'cityId'
export const COLOR = 'color'
export const CONTRACT_ID = 'contractId'
export const CUBIC_CAPACITY = 'cubicCapacity'
export const FINANCED_PRICE = 'financedPrice'
export const FUEL_TYPE = 'fuelType'
export const HP = 'hp'
export const IS_PROFESSIONAL = 'isProfessional'
export const KM = 'km'
export const LUGGAGE_CAPACITY = 'luggageCapacity'
export const MAIN_PROVINCE = 'mainProvince'
export const MAKE = 'make'
export const MIXED_CONSUMPTION = 'mixedConsumption'
export const MODEL = 'model'
export const MODEL_VERSION_KEYWORD = 'modelVersionKeyword'
export const OFFER_TYPE_ID = 'offerTypeId'
export const PRICE = 'price'
export const REGION_ID = 'regionId'
export const SEATING_CAPACITY = 'seatingCapacity'
export const TRANSMISSION_TYPE = 'transmissionType'
export const TRIM_LEVEL = 'trimLevel'
export const VERSION = 'version'
export const YEAR = 'year'

export const FILTER_NAMES_TO_AGGREGATIONS_DICTIONARY = {
  [FILTER_NAMES.BODY_TYPE]: BODY_TYPE,
  [FILTER_NAMES.CATEGORY_1]: CATEGORY_1_ID,
  [FILTER_NAMES.CITY]: CITY_ID,
  [FILTER_NAMES.COLOR]: COLOR,
  [FILTER_NAMES.CONTRACT]: CONTRACT_ID,
  [FILTER_NAMES.LITRES]: CUBIC_CAPACITY,
  [FILTER_NAMES.INSTALMENT]: FINANCED_PRICE,
  [FILTER_NAMES.FUEL_TYPE]: FUEL_TYPE,
  [FILTER_NAMES.HP]: HP,
  [FILTER_NAMES.KM]: KM,
  [FILTER_NAMES.LUGGAGE_CAPACITY]: LUGGAGE_CAPACITY,
  [FILTER_NAMES.PROVINCE]: MAIN_PROVINCE,
  [FILTER_NAMES.MAKE]: MAKE,
  [FILTER_NAMES.MODEL]: MODEL,
  [FILTER_NAMES.OFFER_TYPE]: OFFER_TYPE_ID,
  [FILTER_NAMES.PRICE]: PRICE,
  [FILTER_NAMES.SEAT]: SEATING_CAPACITY,
  [FILTER_NAMES.TRANSMISSION_TYPE]: TRANSMISSION_TYPE,
  [FILTER_NAMES.VERSION]: VERSION,
  [FILTER_NAMES.YEAR]: YEAR
}

export const AGGREGATIONS_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: [
    {
      aggregation: CATEGORY_1_ID,
      nestedAggregation: OFFER_TYPE_ID
    },
    {
      aggregation: MAKE
    }
  ]
}
